const allowedKeysRegex = /^\d{1}$/

export const dobMask = [
  allowedKeysRegex,
  allowedKeysRegex,
  '/',
  allowedKeysRegex,
  allowedKeysRegex,
  '/',
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
  allowedKeysRegex,
]
